export const errorTypes = {
  NOT_ENOUGH_DATA: 'NOT_ENOUGH_DATA',
  UNAUTHORIZED: 'UNAUTHORIZED'
}
